import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const VideoSection = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10">

          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            See <span className="text-gradient">AdV3nture</span> in Action
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Explore the live AdV3nture experience right here, no signup required.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="max-w-6xl mx-auto">
          <div className="glass rounded-2xl p-2 sm:p-3 overflow-hidden">
            <div className="flex items-center gap-1.5 px-3 py-2 border-b border-border/40">
              <span className="w-2.5 h-2.5 rounded-full bg-destructive/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-secondary/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-primary/60" />
              <span className="ml-3 text-xs text-muted-foreground font-mono truncate">
                app.adv3nture.io
              </span>
            </div>
            <div className="relative w-full aspect-[4/3] sm:aspect-[16/10] rounded-b-xl overflow-hidden bg-muted/30">
              <iframe
                src="https://app.adv3nture.io"
                title="AdV3nture live app preview"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                className="absolute inset-0 w-full h-full border-0"
              />
            </div>
          </div>
          <div className="text-center mt-6">
            <Button asChild variant="outline" size="sm" className="gap-2">
              <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
                Open full app <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>);

};

export default VideoSection;